import React, { createContext, useContext, useEffect } from "react";
import { Sparkles } from "lucide-react";

export interface ClinicianAssistantController {
  open: () => void;
  triggerRef: React.RefObject<HTMLButtonElement>;
  setTeamScopeFilters: (filters: ClinicianAssistantTeamScopeFilters) => void;
}

export interface ClinicianAssistantTeamScopeFilters {
  clinicId: string;
  therapistId: string;
}

export const ClinicianAssistantControllerContext =
  createContext<ClinicianAssistantController | null>(null);

export function useClinicianAssistantTeamScopeFilters({
  clinicId = "",
  therapistId = "",
}: Partial<ClinicianAssistantTeamScopeFilters>) {
  const controller = useContext(ClinicianAssistantControllerContext);

  useEffect(() => {
    if (!controller) return;
    controller.setTeamScopeFilters({ clinicId, therapistId });
    return () =>
      controller.setTeamScopeFilters({ clinicId: "", therapistId: "" });
  }, [clinicId, controller, therapistId]);
}

export function ClinicianAssistantHeaderButton() {
  const controller = useContext(ClinicianAssistantControllerContext);
  if (!controller) return null;
  return (
    <button
      ref={controller.triggerRef}
      type="button"
      className="cp-button cp-button--secondary cp-clinician-assistant__trigger"
      onClick={controller.open}
      aria-haspopup="dialog"
    >
      <Sparkles aria-hidden="true" />
      Ask Assistant
    </button>
  );
}
